const {KitModule, registerModule, Flickity} = window;

// Add and remove a resizing class to get equal height cells
const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  resize.call(this);
  this.element.classList.add('flickity-resize');
};

class FeaturedPostsCarousel extends KitModule {
  constructor($element) {
    super($element);

    if (this.$carousel) {
      // The carousel is only rendered if there are more than two items, so we
      // shouldn't attempt to initialize Flickity or related elements if it
      // doesn't exist.
      this.initFlickity();
    }
  }

  handleFlickitySelect() {
    // progress dots update on select
    // update prev/next buttons
    // disabled if first / last
    if (!this.flkty.cells[this.flkty.selectedIndex - 1]) {
      this.$nextBtn.removeAttribute('disabled');
      this.$previousBtn.setAttribute('disabled', 'disabled');
    } else if (this.flkty.cells[this.flkty.selectedIndex + 1]) {
      this.$previousBtn.removeAttribute('disabled');
      this.$nextBtn.removeAttribute('disabled');
    } else {
      this.$previousBtn.removeAttribute('disabled');
      this.$nextBtn.setAttribute('disabled', 'disabled');
    }
  }

  handleNext() {
    this.flkty.next();
    this.render();
  }

  handlePrevious() {
    this.flkty.previous();
    this.render();
  }

  initFlickity() {
    this.flkty = new Flickity(this.$carousel, {
      cellAlign: 'left',
      contain: false,
      freeScroll: true,
      freeScrollFriction: 0.1,
      imagesLoaded: true,
      pageDots: false,
      prevNextButtons: false,
    });

    // Recalc position from unhide/lazy load
    window.addEventListener('load', () => {
      this.flkty.reloadCells();
      this.flkty.resize();
    });

    // custom prev/next
    this.$previousBtn?.addEventListener('click', this.handlePrevious.bind(this));
    this.$nextBtn?.addEventListener('click', this.handleNext.bind(this));

    this.flkty.on('select', this.handleFlickitySelect.bind(this) );
  }

  render() {
    this.$currentItem.innerText = this.flkty.selectedIndex + 1;
  }

  unmount() {
    this.flkty.destroy();
  }
}

registerModule('FeaturedPostsCarousel', FeaturedPostsCarousel);
